// ESM-Huelle fuer lib/scripts/components/CMP_CKeyboard.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CKeyboard (id)
{
    this.construct (id);

    this.name = "CKeyboard";
    this.htmlType = "span";

    this.Pp = null;
    this.controlFields = new Array ();
    this.properties =
    {
        rows: 3,
        columns: 13, //11
        ok: false,
        cancel: false,
        buttons:
        {
            caption:
            {
                styles:
                {
                    fontSize: "3.0vh",
                    fontWeight: "bold",
                    color: "#6A5F3C"
                }
            },
            styles:
            {
                borderRadius: "14px",
                backgroundColor: "#E0C983",
                borderColor: "#B1A272"
            },
            events: null
        },
        styles:
        {
            backgroundColor: "#F2E9CC",
            width: "97.65%",
            height: "20%"
        },
        callback:
        {
            cls: null,
            fnc: null
        }
    }
}

CKeyboard.prototype = new CComponent;

CKeyboard.prototype.prepare = function ()
{
    this.Pp = this.addChild (CPushPanel);

    this.Pp.clickWork = this.clickWork;

    this.Pp.properties = combine (this.Pp.properties, this.properties);
    
    var keys, keyValues;

    keys = new Array ("Q", "W", "E", "R", "T", "Z", "U", "I", "O", "P", "&Uuml;",
        "@", ".", "A", "S", "D", "F", "G", "H", "J", "K", "L", "&Ouml;", "&Auml;",
        "-", "+", "Y", "X", "C", "V", "B", "N", "M", "&szlig;", "/", "_", " ");
    keyValues = new Array ("Q", "W", "E", "R", "T", "Z", "U", "I", "O", "P", "\u00DC",
        "@", ".", "A", "S", "D", "F", "G", "H", "J", "K", "L", "\u00D6", "\u00C4",
        "-", "+", "Y", "X", "C", "V", "B", "N", "M", "\u00DF", "/", "_", " ");

/*    keys = new Array ("Q", "W", "E", "R", "T", "Z", "U", "I", "O", "P", "&Uuml;",
        "A", "S", "D", "F", "G", "H", "J", "K", "L", "&Ouml;", "&Auml;",
        "Y", "X", "C", "V", "B", "N", "M", "&szlig;", "/", " ");
    keyValues = new Array ("Q", "W", "E", "R", "T", "Z", "U", "I", "O", "P", "�",
        "A", "S", "D", "F", "G", "H", "J", "K", "L", "�", "�",
        "Y", "X", "C", "V", "B", "N", "M", "�", "/", " ");*/

    for (var i in keys)
    {
        this.Pp.buttons[i] = new CPushButton;
        this.Pp.buttons[i].properties = combine (this.Pp.buttons[i].properties,
            this.Pp.properties.buttons);
        if (keys[i] == " ")
            this.Pp.buttons[i].properties.styles.width = "22.2%";
        this.Pp.buttons[i].properties.caption.value = keys[i].toString();
        this.Pp.buttons[i].properties.keyValue = keyValues[i].toString();
        this.Pp.buttons[i].properties.events.onMousedown = this.Pp.clickWork;
    }

    this.prepared = true;
}

CKeyboard.prototype.clickWork = function (component, parameters)
{
    if (POS.focusedComponent != null &&
         typeof POS.focusedComponent.gotKey == "function")
    {
	
        POS.focusedComponent.gotKey (component.properties.keyValue);
    }
}
export { CKeyboard };
